/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Seat_Price_Monthly_Up_NextInputs */



/**
* | output |
* | --- |
* | "From your next renewal, your monthly bill goes up by {amount} (excl. VAT)." |
*
* @param {Seat_Price_Monthly_Up_NextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_price_monthly_up_next = /** @type {((inputs: Seat_Price_Monthly_Up_NextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Price_Monthly_Up_NextInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ab Ihrer nächsten Verlängerung steigt Ihre Monatsrechnung um ${i?.amount} (zzgl. MwSt.).`)
	return /** @type {LocalizedString} */ (`From your next renewal, your monthly bill goes up by ${i?.amount} (excl. VAT).`)
});